// @ts-nocheck

/* eslint-disable no-undef */

/* eslint-disable arrow-body-style */
import * as hosts from './hostLocations';

export function getAppsByPage(
  page: any,
  pageSkip: any,
  showTotal: any,
  callback: any,
) {
  return function () {
    const host = hosts.ACTIVE_HOST + '/app/fetchAppsByPage';

    const data = {
      page: page,
      pageSkip: pageSkip,
    };

    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('jwtToken'),
      },
      method: 'post',
      body: JSON.stringify(data),
    };

    fetch(host, options)
      .then(response => {
        return response.json();
      })
      .then(results => {
        if (callback) {
          if (showTotal) {
            callback(page, results.users, results.total);
          } else {
            callback(page, results.users);
          }
        }
      })
      .catch(error => {
        alert('There was an error with your request.');
        throw error;
      });
  };
}

export function fetchPaginatedFilteredData(
  pageSize: any,
  page: any,
  sorted: any,
  searchTerm: any,
  customerMode: any,
  archiveMode: any,
  callback: any,
) {
  return function () {
    const host = hosts.ACTIVE_HOST + '/app/fetchPaginatedFilteredApps';

    const data = {
      pageSize,
      page,
      sorted,
      searchTerm,
      customerMode,
      archiveMode,
      socialMode: false,
    };

    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('jwtToken'),
      },
      method: 'post',
      body: JSON.stringify(data),
    };
    fetch(host, options)
      .then(response => {
        return response.json();
      })
      .then(results => {
        if (callback) {
          callback(results);
        }
      })
      .catch(error => {
        alert('There was an error with your request.');
        throw error;
      });
  };
}

// new dashboard stuff

export function getTrendingItemsAdmin(idToUse: any, callback: any) {
  // eslint
  return function () {
    const host = hosts.ACTIVE_HOST + '/app/fetch';

    const data = {
      appId: idToUse,
      adminMode: true,
    };

    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('jwtToken'),
      },
      method: 'post',
      body: JSON.stringify(data),
    };

    fetch(host, options)
      .then(response => {
        return response.json();
      })
      .then(results => {
        if (callback) {
          callback(results);
        }
      })
      .catch(error => {
        alert('There was an error with your request.  (Trending)');
        throw error;
      });
  };
}

export function fetchGraphDataAdmin(appId: any, range: any, callback: any) {
  return function () {
    const host = hosts.ACTIVE_HOST + '/app/fetchGraphData';
    const data = {
      appId: appId,
      range: range,
      adminMode: true,
    };
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('jwtToken'),
      },
      method: 'post',
      body: JSON.stringify(data),
    };
    fetch(host, options)
      .then(response => {
        return response.json();
      })
      .then(dataReturned => {
        if (callback) {
          callback(dataReturned, range);
        }
      })
      .catch(error => {
        // alert(error);
        throw error;
      });
  };
}

export function fetchOrderDataAdmin(appId: any, callback: any) {
  return function () {
    const host = hosts.ACTIVE_HOST + '/payment/getReviewInfo';
    const data = {
      appId: appId,
      adminMode: true,
      // range: range
    };
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('jwtToken'),
      },
      method: 'post',
      body: JSON.stringify(data),
    };
    fetch(host, options)
      .then(response => {
        return response.json();
      })
      .then(dataReturned => {
        if (callback) {
          callback(dataReturned);
        }
      })
      .catch(error => {
        // alert(error);
        throw error;
      });
  };
}

export function fetchSessionGraphDataAdmin(
  appId: any,
  range: any,
  callback: any,
) {
  return function () {
    const host = hosts.ACTIVE_HOST + '/app/fetchSessionGraphData';
    const data = {
      appId: appId,
      range: range,
      adminMode: true,
    };
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('jwtToken'),
      },
      method: 'post',
      body: JSON.stringify(data),
    };
    fetch(host, options)
      .then(response => {
        return response.json();
      })
      .then(dataReturned => {
        if (callback) {
          callback(dataReturned, range);
        }
      })
      .catch(error => {
        // alert(error);
        throw error;
      });
  };
}

export function fetchAbandonedCartGraphDataAdmin(
  appId: any,
  range: any,
  callback: any,
) {
  return function () {
    const host = hosts.ACTIVE_HOST + '/app/fetchAbandonedCartGraphData';
    const data = {
      appId: appId,
      range: range,
      adminMode: true,
    };
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('jwtToken'),
      },
      method: 'post',
      body: JSON.stringify(data),
    };
    fetch(host, options)
      .then(response => {
        return response.json();
      })
      .then(dataReturned => {
        if (callback) {
          callback(dataReturned, range);
        }
      })
      .catch(error => {
        // alert(error);
        throw error;
      });
  };
}

export function fetchLastLoggedInGraphDataAdmin(
  appId: any,
  range: any,
  callback: any,
) {
  return function () {
    const host = hosts.ACTIVE_HOST + '/app/fetchLastLoggedInGraphData';
    const data = {
      appId: appId,
      range: range,
      adminMode: true,
    };
    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('jwtToken'),
      },
      method: 'post',
      body: JSON.stringify(data),
    };
    fetch(host, options)
      .then(response => {
        return response.json();
      })
      .then(dataReturned => {
        if (callback) {
          callback(dataReturned, range);
        }
      })
      .catch(error => {
        // alert(error);
        throw error;
      });
  };
}
